let Domain = ''
if (process.env.NODE_ENV === 'production') {
  Domain = 'https://ahoke-mini-api.gymooit.cn/v1'
} else {
  Domain = 'https://ahoke-mini-api.gymooit.cn/v1'// https://ahoke-mini-api.gymooit.cn/v1
}

const ApiDomain = `${Domain}/cms`// api域名
const proImgDomain = 'http://thirdwx.qlogo.cn/mmopen/vi_32/'// 生成环境图片域名
const qnImgDomain = 'https://cdn.gymoo.cn/' // 七牛云图片地址
const qnUploadImgDomain = 'https://upload-z2.qiniup.com' // 7牛云图片上传地址
const qnTokenDomain = `${Domain}/qn` // 七牛token

const uploadPeopleFileDomain = `${ApiDomain}/enterprise/user/excel` // 导入员工execl

export default {
  Domain,
  ApiDomain,
  qnTokenDomain,
  qnImgDomain,
  qnUploadImgDomain,
  proImgDomain,
  uploadPeopleFileDomain
}
